import { BiCog } from 'react-icons/bi';
import './GeneralSettingsReaders.css'
import Container from '../../../components/Container/Container';
import { useEffect, useState } from 'react';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { ConfigAlphadigi } from './ConfigAlphadigi';
import { ConfigAvicam } from './ConfigAvicam';
import { ConfigCtrlID } from './ConfigCtrlID';
import { ConfigHikvision } from './ConfigHikvision';
import { ConfigIntelbras } from './ConfigIntelbras';
import { ConfigPositivo } from './ConfigPositivo';
import { ConfigQrcode } from './ConfigQrcode';
import { ConfigSemParar } from './ConfigSemParar';
import { ConfigUniview } from './ConfigUniview';
import { useNavigate, useParams } from 'react-router-dom';
import { ReaderModel } from '../../../constants/readers-model';
import { AnimatedTabbar, AnimatedTabbarItem } from '../../../components/AnimatedTabbar/AnimatedTabbar';
import { ConfigWeg } from './ConfigWeg';

export function GeneralSettingsReaders() {
   const { readerModel } = useParams();
   const navigate = useNavigate();
   const [selectedTab, setSelectedTab] = useState(ReaderModel.AlphaDigi.slug);

   useEffect(() => {
      setSelectedTab(readerModel ?? ReaderModel.AlphaDigi.slug);
   }, [readerModel]);

   return (
      <div className="consulta-container">
         <Container>
            <PageTitle
               className="border-none! mb-0!"
               icon={<BiCog size={20} />}
               title="Configuração dos Serviços de Leitoras IP"
            />
            <div className="mt-2! w-full border-b! border-(--borderColor)!">
               <AnimatedTabbar
                  value={selectedTab}
                  className={`border-none!`}
                  onChange={value => navigate(`../configuracoes-gerais-leitoras/${value}`)}
               >
                  {Object.entries(ReaderModel).map(([key, modelData]) => (
                     <AnimatedTabbarItem name={modelData.slug} key={key}>
                        <span>{modelData.name}</span>
                     </AnimatedTabbarItem>
                  ))}
               </AnimatedTabbar>
            </div>
            <div className='mt-2!'>
               {selectedTab === ReaderModel.AlphaDigi.slug && <ConfigAlphadigi />}
               {selectedTab === ReaderModel.Avicam.slug && <ConfigAvicam />}
               {selectedTab === ReaderModel.CtrlID.slug && <ConfigCtrlID />}
               {selectedTab === ReaderModel.Hikvision.slug && <ConfigHikvision />}
               {selectedTab === ReaderModel.Intelbras.slug && <ConfigIntelbras />}
               {selectedTab === ReaderModel.Positivo.slug && <ConfigPositivo />}
               {selectedTab === ReaderModel.QRCODE.slug && <ConfigQrcode />}
               {selectedTab === ReaderModel.SEM_PARAR.slug && <ConfigSemParar />}
               {selectedTab === ReaderModel.Uniview.slug && <ConfigUniview />}
               {selectedTab === ReaderModel.Weg.slug && <ConfigWeg />}
            </div>
         </Container>
      </div>
   );
}